import React, { useState } from "react";
import "./App.css";
import WeatherApp from "./Components/WeatherApp/WeatherApp";

function App() {
 
  return (
    <div>
     <WeatherApp></WeatherApp>
    </div>
  );
}

export default App;
